//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custactWork', {
//        templateUrl: 'views/components/views/custactWork/custactWork.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'custactWorkService', 'logisticService', 'economyService', function ($stateParams, stateService, utilityService, modalService, translateService, custactWorkService, logisticService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custactNo = $stateParams.custact_no;
//            let custactWorkKeyno = $stateParams.custactwork_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                custactWorkKeyno: custactWorkKeyno,
//                equipmentsButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('equipment_id') }
//                ],
//                info: {},
//                edit: {},
//                selectListOperations: [],
//                selectListEquipments: [],
//                lockedSaveAndNew: false,
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS
            
//            async function loadInfo() {
//                vm.model.info = (await economyService.getCustomerActivity({ custact_no: custactNo }))[0];
//            }

//            async function loadEdit() {
//                vm.model.edit = (await custactWorkService.getEdit({
//                    custact_no: custactNo,
//                    custactwork_keyno: custactWorkKeyno
//                }))[0];
//            }
            
//            async function loadOperations() {
//                vm.model.selectListOperations = await logisticService.listOperations({ direct: '1' });
//            }
            
//            async function loadEquipments() {
//                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;
                
//                return vm.model.selectListEquipments = await logisticService.listEquipments({ operation_id: vm.model.edit.operation_id });
//            }

//            async function retrieveProduct() {
//                if (utilityService.validateParmsValue(vm.model.edit.operation_id, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.equipment_id, true) !== true) return;
                
//                const response = (await custactWorkService.getProduct({
//                    operation_id: vm.model.edit.operation_id,
//                    equipment_id: vm.model.edit.equipment_id
//                }))[0];

//                vm.model.edit.prod_id = response?.prod_id;
//                vm.model.edit.prodsize_keyno = response?.prodsize_keyno;
//                vm.model.edit.prodchoice_keyno = response?.prodchoice_keyno;
//            }
            
//            async function retrievePrice() {
//                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.operation_id, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.equipment_id, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.prod_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.prodsize_keyno) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.prodchoice_keyno) !== true) return;
                
//                const response = (await custactWorkService.getPrice({
//                    custact_no: vm.model.edit.custact_no,
//                    operation_id: vm.model.edit.operation_id,
//                    equipment_id: vm.model.edit.equipment_id,
//                    prod_id: vm.model.edit.prod_id,
//                    prodsize_keyno: vm.model.edit.prodsize_keyno,
//                    prodchoice_keyno: vm.model.edit.prodchoice_keyno
//                }))[0];

//                vm.model.edit.cost_price_invval = response?.cost_price_invval;
//                vm.model.edit.ordval_price_brt = response?.ordval_price_brt;
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region RESET BUTTON FUNCTION

//            async function clear(id) {
//                switch (id) {
//                    case 'equipment_id':
//                        vm.model.edit.equipment_id = '';

//                        await retrieveProduct();

//                        Promise.all([
//                            retrievePrice()
//                        ]).then(() => {
//                            calculateCost();
//                            calculatePrice();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region RECALC FUNCTIONS
            
//            function calculateCost() {
//                vm.model.edit.cost_locval = utilityService.parseNumber(vm.model.edit.cost_price_invval) * utilityService.parseNumber(vm.model.edit.quantity_hours);
//            }
            
//            function calculatePrice() {
//                vm.model.edit.ordval_amount_net = utilityService.parseNumber(vm.model.edit.ordval_price_brt) * utilityService.parseNumber(vm.model.edit.quantity_hours);
//            }
            
//            function calculateExchangeAmount() {
//                vm.model.edit.locval_amount_net = utilityService.parseNumber(vm.model.edit.ordval_amount_net) * utilityService.parseNumber(vm.model.edit.ordval_exchangefactor);
//            }
            
//            function calculateLocValAmount() {
//                vm.model.edit.locval_db = utilityService.parseNumber(vm.model.edit.ordval_amount_net) - utilityService.parseNumber(vm.model.edit.cost_locval);
//            }

//            // #endregion RECALC FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveAndNewChanges = function () {
//                vm.model.lockedSaveAndNew = true;

//                custactWorkService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSaveAndNew = false;

//                    stateService.go('custactwork', {
//                        custact_no: vm.model.edit.custact_no,
//                        custactwork_keyno: '0'
//                    });

//                    Promise.all([
//                        translate(),
//                        loadEdit(),
//                        loadInfo(),
//                        loadOperations()
//                    ]).then(() => {
//                        loadEquipments();
//                        Promise.resolve();
//                    });
//                }, function () {
//                    vm.model.lockedSaveAndNew = false;
//                });
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                custactWorkService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back('/custactworks/' + vm.model.edit.custact_no);
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    custactWorkService.deleteItem({ custactwork_keyno: $stateParams.custactwork_keyno }).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL
            
//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = async function (value, id) {
//                switch (id) {
//                    case 'quantity_hours':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.quantity_hours) !== true) return;

//                        vm.model.edit.quantity_hours = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.quantity_hours) !== true) return;

//                        calculateCost();
//                        calculatePrice();
//                        break;
//                    case 'operation_id':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.operation_id) !== true) return;

//                        vm.model.edit.operation_id = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

//                        loadEquipments();
//                        await retrieveProduct();

//                        Promise.all([
//                            retrievePrice()
//                        ]).then(() => {
//                            calculateCost();
//                            calculatePrice();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'equipment_id':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.equipment_id) !== true) return;

//                        vm.model.edit.equipment_id = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.equipment_id) !== true) return;

//                        await retrieveProduct();

//                        Promise.all([
//                            retrievePrice()
//                        ]).then(() => {
//                            calculateCost();
//                            calculatePrice();
//                            Promise.resolve();
//                        });
//                        break;
//                    case 'ordval_amount_net':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.ordval_amount_net) !== true) return;

//                        vm.model.edit.ordval_amount_net = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.ordval_amount_net) !== true) return;

//                        calculateExchangeAmount();
//                        calculateLocValAmount();
//                        break;
//                    case 'cost_locval':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.cost_locval) !== true) return;

//                        vm.model.edit.cost_locval = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.cost_locval) !== true) return;

//                        calculateLocValAmount();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadInfo();
//                loadOperations();
//                loadEquipments();
//            }

//            // #endregion ON INIT FUNCTION
            
//        }]
//    });
//})();
